export default {"src":"/_next/static/media/0xc2132d05d31c914a87c6611c10748aeb04b58e8f.fc08aec8.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};